<template>
<div class="rp">

    <!-- ════════════════════ DASHBOARD HEADER ════════════════════ -->
    <div class="rp-dash-header">
      <div class="rp-dash-header-top">
        <div>
          <div class="rp-eyebrow">TALLER · ISSUE TRACKER</div>
          <h1 class="rp-title">Reportes de problemas</h1>
        </div>
        <div class="rp-header-actions">
          <div class="rp-stat-pill rp-stat-pill--danger" v-if="reportsNoFixed.length > 0">
            <i class="fa-solid fa-triangle-exclamation"></i>
            <strong>{{ reportsNoFixed.length }}</strong>
            <span>sin resolver</span>
          </div>
          <div class="rp-stat-pill rp-stat-pill--success">
            <i class="fa-solid fa-check-double"></i>
            <strong>{{ reportFixed.length }}</strong>
            <span>resueltos</span>
          </div>
          <button class="rp-btn rp-btn--primary" @click="openReport()">
            <i class="fa-solid fa-plus"></i>
            <span>Nuevo reporte</span>
          </button>
        </div>
      </div>
    </div>

  <b-card-code title="Problemas Sin Resolver">
    
        <b-table
            :items="reportsNoFixed"
            :fields="columnasReportes"
            class="table table-borderless table-prevision"
            no-border-collapse
            sort-icon-left
            striped 
            ref="tableReports"
          >

            <template #cell(options)="data">              
              <b-button variant="outline-success" class="btn-circle" @click="reportSolucionado(data.item)"><i class="fa-solid fa-check-double"></i></b-button>
            </template>

            <template #cell(sku)="data">              
              <span>{{data.item.sku}}-{{data.item.color}}</span>
            </template>

        </b-table>
    </b-card-code>

    <br>

    <b-card-code title="Problemas Resueltos">
        <b-table
            :items="reportFixed"
            :fields="columnasReportesSolucionados"
            class="table table-borderless table-prevision"
            no-border-collapse
            sort-icon-left
            striped 
            ref="tableReports"
          >

            <template #cell(sku)="data">              
              <span>{{data.item.sku}}-{{data.item.color}}</span>
            </template>

        </b-table>
    </b-card-code>

    <b-modal
            id="modal-report"
            ref="modal-report"
            ok-only
            ok-title="Accept"
            centered
            hide-footer
            size="LG"
            modal-class="rp-modal"
            :title="'Reportar problema'"
        >
          <b-row class="match-height">
              <b-col cols="12">
                  
                  <b-row class="match-height" >
                    <b-col cols="6">
                        <b-form-group style="width: 100%">                          
                          <label for="sping-cortado">Categoria</label>
                          <v-select
                            v-model="categoriaSelect"
                            label="nombre"
                            :options="listadoCategoria"
                          />
                        </b-form-group>
                    </b-col>
                    <b-col cols="6">
 
                    <label for="sping-cortado">Color</label>
                    <b-form-input
                        placeholder=""
                        v-model="color"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="match-height" style="margin-top: 10px">
                    <b-col cols="12">
 
                       <label for="sping-cortado">Modelo</label>
                       <b-form-input
                          placeholder=""
                          v-model="sku"
                        />
                    </b-col>
                    
                  </b-row>
                  <b-row class="match-height" style="margin-top: 10px">
                  <!--categoria-->
                  <!--Descripcion-->
                    <b-col cols="12">
                      <label for="sb-disabled">Descripcion</label>
                        <b-form-textarea
                            id="descripcionReportInput"
                            ref="descripcionReportInput"
                            placeholder=""
                            rows="4"
                            v-model="descripcion"
                          />
                    </b-col>
                  </b-row>
                  <br>
                  <b-button variant="outline-primary" @click="guardarReporte()">
                    <i class="fa-solid fa-triangle-exclamation"></i>
                    <span class="align-middle"> Crear reporte</span>
                  </b-button>

              </b-col>

          </b-row>

        </b-modal>
</div>
</template>


<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable, BFormInput, BFormGroup, BRow, BCol} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'

  export default {
    components: {
        BCardCode,
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        vSelect,
    },
    data () {
      return {
         columnasReportes: [
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "sku",
          label: "Sku",
          sortable: true,
          thStyle: { width: "20%" },
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "seccion",
          label: "Seccion",
          sortable: false,
        },
        {
          key: "color",
          label: "Color",
          sortable: false,
        },
         {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        }
        ],
        columnasReportesSolucionados: [
        {
          key: "fecha",
          label: "Creado",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "fechaSolucionado",
          label: "Solucionado",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "sku",
          label: "Sku",
          sortable: true,
          thStyle: { width: "20%" },
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "seccion",
          label: "Seccion",
          sortable: false,
        },
        {
          key: "color",
          label: "Color",
          sortable: false,
        },
         {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },{
          key: "options",
          label: "",
          thStyle: { width: "10%" },
        }
        ],
        allReports: [],
        reportFixed: [],
        reportsNoFixed: [],
        descripcion: '',
        categoria: '',
        sku: '',
        color: '',
        listadoCategoria: ['Corte','Preparado','Confeccion','General'],
        categoriaSelect: ''
      }
    },
    methods: {
        async load()
        {
          axios.post("/uso", {seccion:"reportes"});
            const responseReportes = await axios.get("/taller/reportes");
            const resReportes = responseReportes.data;

            this.allReports = resReportes;

            this.reportsNoFixed = this.allReports.filter(objeto => objeto.solucionado === 0);
            this.reportFixed = this.allReports.filter(objeto => objeto.solucionado === 1);
        },
        reportSolucionado(data){
        
         axios
            .post("/taller/reporte/solucionado/"+data.id)
            .then(response => {
                return response.data;
            })
            .then(res => {

              //this.allReports = this.allReports.filter(obj => obj.id !== data.id);

              data.solucionado = 1;

              this.reportsNoFixed = this.allReports.filter(objeto => objeto.solucionado === 0);
              this.reportFixed = this.allReports.filter(objeto => objeto.solucionado === 1);

              this.$swal({
                  icon: 'success',
                  title: 'El reporte se ha corregido correctamente',
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })

            });
      },
      openReport(){
        this.descripcion = '';
        this.categoria = '';
        this.sku = '';
        this.color = '';

        this.$refs['modal-report'].show();
      },
      guardarReporte(){
        const fechaActual = new Date();
        const dia = fechaActual.getDate().toString().padStart(2, '0');
        const mes = (fechaActual.getMonth() + 1).toString().padStart(2, '0');
        const anio = fechaActual.getFullYear().toString();

        let dataReport = {
          descripcion: this.descripcion, 
          categoria: this.categoriaSelect,
          sku: this.sku,
          color: this.color,
          idPedido: null,
          fecha: `${dia}-${mes}-${anio}`,
          seccion: 'General',
          fechaSolucionado: '',
          solucionado: 0,
          id: 0
        }

        axios
          .post("/taller/pieza/reporte", dataReport)
          .then(response => {
              return response.data;
          })
          .then(res => {

              this.$swal({
                  icon: 'success',
                  title: 'Report creado',
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })

              dataReport.id = res.insertId;

              this.allReports.push(dataReport);
              this.reportsNoFixed.push(dataReport);
          });

          this.$refs['modal-report'].hide();
      }

    },
    mounted() {
      this.load();
    },
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

// ══════════════════════════════════════════════════════════════
// REPORTES — same tokens as /pedido-taller-vero/fabricando
// ══════════════════════════════════════════════════════════════

$rp-bg:        #F8FAFC;
$rp-surface:   #FFFFFF;
$rp-surface-2: #F1F5F9;
$rp-border:    #E2E8F0;
$rp-divider:   #EEF2F7;
$rp-ink:       #1E293B;
$rp-mute:      #64748B;
$rp-soft:      #94A3B8;
$rp-primary:   #3B82F6;
$rp-cta:       #F97316;
$rp-emerald:   #10B981;
$rp-coral:     #EF4444;

.rp {
  font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
  background: $rp-bg;
  color: $rp-ink;
  margin: -2rem;
  padding: 28px 32px 56px;
  min-height: calc(100vh - 4rem);
  font-feature-settings: "tnum", "zero";

  *, *::before, *::after { box-sizing: border-box; }

  // ──────────── HEADER ────────────
  .rp-dash-header {
    background: $rp-surface;
    border: 1px solid $rp-border;
    border-radius: 14px;
    padding: 18px 20px 16px;
    margin-bottom: 18px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  }

  .rp-dash-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    flex-wrap: wrap;
  }

  .rp-eyebrow {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 600;
    color: $rp-primary;
    letter-spacing: 0.14em;
    margin-bottom: 4px;

    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      background: $rp-cta;
      border-radius: 50%;
      margin-right: 6px;
      vertical-align: middle;
      animation: rp-pulse 2s infinite;
    }
  }

  .rp-title {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 22px;
    font-weight: 700;
    color: $rp-ink;
    line-height: 1.1;
    letter-spacing: -0.01em;
    margin: 0;
  }

  .rp-header-actions {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
  }

  .rp-stat-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;
    padding: 0 14px;
    background: $rp-bg;
    border: 1px solid $rp-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: $rp-mute;

    i { color: $rp-primary; font-size: 12px; }
    strong {
      font-family: 'JetBrains Mono', monospace;
      font-size: 13px;
      font-weight: 700;
      color: $rp-ink;
      font-feature-settings: "tnum";
    }

    &--danger {
      background: rgba(239, 68, 68, 0.06);
      border-color: rgba(239, 68, 68, 0.2);
      color: $rp-coral;
      i { color: $rp-coral; }
      strong { color: $rp-coral; }
    }
    &--success {
      background: rgba(16, 185, 129, 0.06);
      border-color: rgba(16, 185, 129, 0.2);
      color: darken($rp-emerald, 8%);
      i { color: $rp-emerald; }
      strong { color: darken($rp-emerald, 8%); }
    }
  }

  .rp-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 38px;
    padding: 0 16px;
    background: $rp-surface;
    border: 1px solid $rp-border;
    border-radius: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: $rp-ink;
    cursor: pointer;
    transition: all 200ms ease;

    i { font-size: 11px; }

    &--primary {
      background: $rp-primary;
      border-color: $rp-primary;
      color: #fff;
      &:hover {
        background: darken($rp-primary, 6%);
        border-color: darken($rp-primary, 6%);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
      }
    }
  }

  // ──────────── B-CARD-CODE OVERRIDES ────────────
  .card,
  .b-card-code {
    background: $rp-surface !important;
    border: 1px solid $rp-border !important;
    border-radius: 14px !important;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
    margin-bottom: 18px !important;

    .card-header {
      background: $rp-surface !important;
      border-bottom: 1px solid $rp-divider !important;
      padding: 16px 20px 14px !important;
      border-left: 0 !important;
      border-radius: 14px 14px 0 0 !important;

      &::before, &::after { display: none !important; }
    }
    .card-title {
      color: $rp-ink !important;
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-weight: 700 !important;
      font-size: 18px !important;
      letter-spacing: -0.015em;
      background: transparent !important;
      border: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      box-shadow: none !important;
      display: flex !important;
      align-items: center !important;
      gap: 8px;
      line-height: 1.2;

      &::before {
        content: '›';
        display: inline-flex;
        align-items: center;
        font-family: 'JetBrains Mono', monospace;
        font-size: 18px;
        font-weight: 800;
        color: $rp-primary;
        line-height: 1;
      }

      &::after { display: none !important; }
    }
    .card-body { padding: 18px 20px !important; }
  }

  // ──────────── B-TABLE ────────────
  .table {
    background: $rp-surface !important;
    margin-bottom: 0 !important;
    font-family: 'Plus Jakarta Sans', sans-serif;

    thead th {
      font-family: 'JetBrains Mono', monospace !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      color: $rp-soft !important;
      letter-spacing: 0.08em !important;
      text-transform: uppercase;
      background: $rp-surface !important;
      border-bottom: 1px solid $rp-border !important;
      border-top: 0 !important;
      padding: 13px 14px !important;
    }
    tbody tr {
      transition: background 150ms ease;
      background: $rp-surface !important;

      td {
        border-top: 1px solid $rp-divider !important;
        font-size: 13px;
        color: $rp-ink !important;
        padding: 11px 14px !important;
        vertical-align: middle;
        background: transparent !important;
      }
      &:hover { background: rgba(59, 130, 246, 0.04) !important; }
    }
  }

  // ──────────── BUTTONS ────────────
  .btn {
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    padding: 8px 14px !important;
    transition: all 200ms ease !important;
    box-shadow: none !important;
    border-width: 1px !important;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 38px;

    i { font-size: 11px; }

    &.btn-outline-success {
      background: rgba(16, 185, 129, 0.08) !important;
      border-color: rgba(16, 185, 129, 0.3) !important;
      color: $rp-emerald !important;
      &:hover { background: $rp-emerald !important; color: #fff !important; border-color: $rp-emerald !important; box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25) !important; }
    }
    &.btn-outline-primary {
      background: transparent !important;
      border-color: $rp-border !important;
      color: $rp-primary !important;
      &:hover { background: rgba(59, 130, 246, 0.06) !important; border-color: $rp-primary !important; }
    }
  }

  .btn-circle {
    width: 36px !important;
    height: 36px !important;
    padding: 0 !important;
    border-radius: 10px !important;
    font-size: 12px !important;
    justify-content: center;
  }

  @keyframes rp-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// ══════════════════════════════════════════════════════════════
// MODAL — REPORTAR PROBLEMA (.rp-modal)
// ══════════════════════════════════════════════════════════════

.rp-modal {
  $m-surface:   #FFFFFF;
  $m-border:    #E2E8F0;
  $m-divider:   #EEF2F7;
  $m-ink:       #1E293B;
  $m-mute:      #64748B;
  $m-soft:      #94A3B8;
  $m-primary:   #3B82F6;
  $m-coral:     #EF4444;
  $m-bg:        #F8FAFC;

  .modal-content {
    background: $m-surface !important;
    border: 1px solid $m-border !important;
    border-radius: 16px !important;
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.2) !important;
    overflow: hidden;
    font-family: 'Plus Jakarta Sans', sans-serif;
    color: $m-ink;
  }

  .modal-header {
    background: $m-surface !important;
    border-bottom: 1px solid $m-divider !important;
    padding: 16px 22px !important;

    .modal-title {
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 17px !important;
      font-weight: 700 !important;
      color: $m-ink !important;
      letter-spacing: -0.015em !important;
      display: inline-flex !important;
      align-items: center;
      gap: 10px;

      &::before {
        content: '›';
        font-family: 'JetBrains Mono', monospace;
        font-size: 20px;
        font-weight: 800;
        color: $m-primary;
        line-height: 1;
      }
    }

    .close {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: $m-bg;
      color: $m-mute;
      opacity: 1;
      font-size: 18px;
      transition: all 150ms ease;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin: 0;
      text-shadow: none;
      &:hover { background: $m-coral; color: #fff; }
    }
  }

  .modal-body {
    padding: 22px;
    background: $m-surface;

    label {
      font-family: 'JetBrains Mono', monospace !important;
      font-size: 10px !important;
      font-weight: 600 !important;
      color: $m-soft !important;
      letter-spacing: 0.1em !important;
      text-transform: uppercase !important;
      margin-bottom: 6px !important;
      display: block;
    }

    .form-control,
    .form-control[type="text"] {
      background: $m-surface !important;
      border: 1px solid $m-border !important;
      border-radius: 8px !important;
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 13px !important;
      height: 38px !important;
      padding: 0 12px !important;
      color: $m-ink !important;
      box-shadow: none !important;

      &::placeholder { color: $m-soft; }
      &:focus {
        outline: none !important;
        border-color: $m-primary !important;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
      }
    }

    textarea.form-control {
      height: auto !important;
      min-height: 110px !important;
      padding: 10px 12px !important;
      line-height: 1.5;
      resize: vertical;
    }

    .v-select {
      .vs__dropdown-toggle {
        background: $m-surface !important;
        border: 1px solid $m-border !important;
        border-radius: 8px !important;
        min-height: 38px;
        padding: 0 6px;
        box-shadow: none !important;
      }
      &.vs--open .vs__dropdown-toggle,
      .vs__dropdown-toggle:focus-within {
        border-color: $m-primary !important;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
      }
      .vs__selected, .vs__search {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 13px;
        color: $m-ink;
        padding: 0 6px;
        line-height: 36px;
      }
      .vs__open-indicator { fill: $m-soft; transform: scale(0.75); }
      .vs__dropdown-menu {
        background: $m-surface;
        border: 1px solid $m-border;
        border-radius: 8px;
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
        padding: 4px;
      }
      .vs__dropdown-option {
        font-family: 'Plus Jakarta Sans', sans-serif;
        font-size: 13px;
        color: $m-ink;
        padding: 8px 10px;
        border-radius: 6px;
        &--highlight { background: $m-bg; color: $m-primary; }
      }
    }

    .btn.btn-outline-primary {
      background: $m-primary !important;
      border-color: $m-primary !important;
      color: #fff !important;
      font-family: 'Plus Jakarta Sans', sans-serif !important;
      font-size: 13px !important;
      font-weight: 600 !important;
      border-radius: 10px !important;
      padding: 10px 22px !important;
      height: auto !important;
      box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25) !important;

      &:hover {
        background: darken($m-primary, 6%) !important;
        border-color: darken($m-primary, 6%) !important;
        box-shadow: 0 6px 18px rgba(59, 130, 246, 0.32) !important;
      }
    }
  }
}

// ══════════ DARK MODE ══════════ (paleta negra, misma que pedidos Vero)
.dark-layout .rp {
  background: #161616;
  color: #d0d2d6;

  .rp-dash-header { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .rp-title { color: #e4e6eb; }
  .rp-stat-pill { background: #161616; border-color: #2c2c2c; color: #8e9099; }
  .rp-stat-pill strong { color: #e4e6eb; }
  .rp-stat-pill--danger, .rp-stat-pill--danger strong { color: #EF4444; }
  .rp-stat-pill--success, .rp-stat-pill--success strong { color: #10B981; }
  .rp-btn:not(.rp-btn--primary) { background: #1f1f1f; border-color: #2c2c2c; color: #d0d2d6; }

  .card,
  .b-card-code {
    background: #1f1f1f !important;
    border-color: #2c2c2c !important;
    box-shadow: none !important;

    .card-header { background: #1f1f1f !important; border-bottom-color: #2c2c2c !important; }
    .card-title { color: #e4e6eb !important; }
  }

  .table {
    background: #1f1f1f !important;

    thead th { background: #1f1f1f !important; color: #8e9099 !important; border-bottom-color: #2c2c2c !important; }
    tbody tr { background: #1f1f1f !important; }
    tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
    tbody tr:hover { background: #242424 !important; }
  }

  .btn.btn-outline-primary { border-color: #2c2c2c !important; }
}

.dark-layout .rp-modal {
  .modal-content { background: #1f1f1f !important; border-color: #2c2c2c !important; color: #d0d2d6; }
  .modal-header { background: #1f1f1f !important; border-bottom-color: #2c2c2c !important; }
  .modal-header .modal-title { color: #e4e6eb !important; }
  .modal-header .close { background: #161616; color: #b4b7bd; }
  .modal-body { background: #1f1f1f; }
  .modal-body label { color: #8e9099 !important; }

  .modal-body .form-control,
  .modal-body .form-control[type="text"] { background: #161616 !important; border-color: #2c2c2c !important; color: #d0d2d6 !important; }
  .modal-body .form-control::placeholder { color: #6e7079; }

  .modal-body .v-select {
    .vs__dropdown-toggle { background: #161616 !important; border-color: #2c2c2c !important; }
    .vs__selected, .vs__search { color: #d0d2d6; }
    .vs__dropdown-menu { background: #1f1f1f; border-color: #2c2c2c; }
    .vs__dropdown-option { color: #d0d2d6; }
    .vs__dropdown-option--highlight { background: #242424; }
  }
}
</style>
